import {
  SETTINGS_WIDGET_CHAT_WELCOME_SKILL_PAGE,
  SETTINGS_WIDGET_CHAT_IDENTITY_SKILL_PAGE,
  SETTINGS_WIDGET_CHAT_OFFLINE_AGENTS_EXISTING_CONVERSATION_SKILL_PAGE,
  SETTINGS_WIDGET_CHAT_UNRESPONSIVE_AGENTS_SKILL_PAGE,
} from 'constants/pages'

import welcomeImage from 'assets/widget/bots/welcome@2x.png'
import identityImage from 'assets/widget/bots/identity@2x.png'
import offlineAgentsImage from 'assets/widget/bots/presence@2x.png'
import unresponsiveAgentsImage from 'assets/widget/bots/unresponsive@2x.png'
import officeHoursImage from 'assets/widget/bots/office_hours@2x.png'
import ratingsImage from 'assets/widget/bots/ratings@2x.png'

export const COMPUTED_SETTINGS_KEYS = ['published', 'primaryColorRgb']

export const BOT_DETAILS = {
  welcome: {
    id: 'welcome',
    title: 'Welcome bot',
    description:
      'Add a welcome message to new conversations with a indicator of reply times.',
    infoMessage:
      'This welcome message will be the default shown when no other automations are running. If you have another bot automation (eg: office hours) that displays a welcome message under certain conditions, that will display and this will not be shown.',
    icon: welcomeImage,
    available: true,
    page: SETTINGS_WIDGET_CHAT_WELCOME_SKILL_PAGE,
  },
  identity: {
    id: 'identity',
    title: 'Require email address for new conversations',
    description:
      'Have your bot gather the customers email address before starting a conversation.',
    infoMessage:
      'Users will only be asked for this once when starting their first conversation.',
    icon: identityImage,
    available: true,
    page: SETTINGS_WIDGET_CHAT_IDENTITY_SKILL_PAGE,
  },
  offlineAgents: {
    id: 'offlineAgents',
    title: `No online ${app.t('agent')} automation`,
    description: `Have your bot inform new and existing users that no ${app.t(
      'agents'
    )} are currently available.`,
    icon: offlineAgentsImage,
    available: true,
    page: SETTINGS_WIDGET_CHAT_OFFLINE_AGENTS_EXISTING_CONVERSATION_SKILL_PAGE,
  },
  unresponsiveAgents: {
    id: 'unresponsiveAgents',
    title: `Unresponsive ${app.t('agent')} automation`,
    description:
      'Display a bot message to when customers don’t get a reply after a set period of time.',
    icon: unresponsiveAgentsImage,
    available: true,
    page: SETTINGS_WIDGET_CHAT_UNRESPONSIVE_AGENTS_SKILL_PAGE,
  },
  officeHours: {
    id: 'officeHours',
    title: 'Office hours',
    description:
      'Have your bot send a automated message informing new and existing customers that they are contacting you outside of office hours',
    icon: officeHoursImage,
    available: false,
    page: null,
  },
  rating: {
    id: 'rating',
    title: 'Satisfaction ratings for closed conversations',
    description:
      'Let your customers leave a rating for recently closed conversations.',
    icon: ratingsImage,
    available: false,
    page: null,
  },
}
